import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = (props) => {
  const {
    host = 'http://localhost:8080',
    path = '/',
    label = 'link',
  } = props;

  const href = `${host}${path}`;

  return (
    <a href={href} target="_blank">{label}</a>
  );
};

ExternalLink.propTypes = {
  host: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
};

export default ExternalLink;
